export default __webpack_public_path__ + "static/media/wrong.978b54f2.svg";